import { cn } from '@/lib/utils';

/**
 * Spinner maison (spec motion du DS : rotation 0,9 s linéaire) — même dessin
 * que celui du Button en loading. Jamais en plein écran : préférer Skeleton.
 */
function Spinner({ className, ...props }: React.ComponentProps<'span'>) {
  return (
    <span
      data-slot="spinner"
      role="status"
      aria-label="Chargement"
      className={cn(
        'inline-block size-4 shrink-0 animate-spin rounded-pill border-2 border-current border-r-transparent opacity-60 animation-duration-[900ms]',
        className,
      )}
      {...props}
    />
  );
}

export { Spinner };
